module.exports = __webpack_public_path__ + "static/media/Givenchy-Black-Logo-Slides-Lyst.3295d512.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/sneakers/Givenchy-Black-Logo-Slides-Lyst.png
// module id = 303
// module chunks = 0